import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedArticles from './components/FeaturedArticles';
import HotTopics from './components/HotTopics';
import CommunityStats from './components/CommunityStats';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import ScrollToTop from '@/components/base/ScrollToTop';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <title>1024社区 - 程序员技术交流与资源分享平台</title>
      <meta name="description" content="1024社区是专为程序员打造的技术交流平台，汇聚海量编程教程、开源项目、技术干货与资源分享。加入1024社区，与百万开发者共同学习、交流、成长，获取最新技术资讯与实战经验。" />
      <meta name="keywords" content="1024社区,1024社区技术论坛,1024社区编程资源,1024社区程序员交流,1024社区开源项目,程序员技术社区,编程学习社区" />
      <link rel="canonical" href="https://1024.community" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content="1024社区 - 程序员技术交流与资源分享平台" />
      <meta property="og:description" content="1024社区是专为程序员打造的技术交流平台，汇聚海量编程教程、开源项目、技术干货与资源分享。" />
      <meta property="og:url" content="https://1024.community" />
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: '1024社区首页',
          description: '1024社区是专为程序员打造的技术交流平台',
          url: 'https://1024.community',
        })}
      </script>

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryGrid />
          <FeaturedArticles />
          <HotTopics />
          <CommunityStats />
          <FAQSection />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
}